import type { ProductsStatusFilter } from '@/stores/uiStore';

const FILTERS: ReadonlySet<string> = new Set<ProductsStatusFilter>([
  'all',
  'active',
  'inactive',
]);

/**
 * `?filter=` on the creator URL preselects the products-step status filter.
 * The overview opens a listing as `?step=products&filter=active`, so the
 * seller sees the products of that listing and nothing else. Case-insensitive
 * like `?step=`; anything unknown leaves the stored filter alone.
 */
export function parseProductsFilterParam(
  value: string | null
): ProductsStatusFilter | null {
  if (!value) return null;
  const lowered = value.toLowerCase();
  return FILTERS.has(lowered) ? (lowered as ProductsStatusFilter) : null;
}
